import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, withRouter } from "react-router-dom";
import ErrorDialog from "~/components/common/dialog";
import dayjs from "~/config/dayjs";
import searchService from "~/services/searchService";
import couponServices from "~/services/couponServices";
import MuiThemeSelectScheduleTime from "./MuiStylesSelectScheduleTime";
import FeaturesSelected from "~/components/common/featuresSelected/FeaturesSelected";
import { Divider, Typography } from "@material-ui/core";
import { Check, Close, ErrorOutline } from "@material-ui/icons";
import ProfessionalDiv from "~/components/common/professionalDiv/ProfessionalDiv";
import BusinessDiv from "~/components/common/businessDiv/BusinessDiv";
import TitleContainer from "~/components/common/titleContainer/TitleContainer";
import { useTranslation } from "react-i18next";
import TimeOptionsDiv from "~/components/common/TimeOptionsDiv";
import { useContext } from "react";
import { DialogBuilder } from "~/utils/DialogProvider";
import ColorButton from "~/components/common/colorButton/ColorButton";
import SEO from "~/components/seo";
import _ from "lodash";
import camelizeKeys from "../../utils/camelizeKeys";
import { mixpanelTrackEvent } from "~/utils/mixpanel";
import { ModalBottom } from "~/components/common/modalBottom/modalBottom";
import useCheckoutPackageOffer from "~/hooks/useCheckoutPackageOffer";
import useCheckSessionPackage from "~/hooks/useCheckSessionPackage";
import PackageOfferModal from "~/components/common/packageOfferModal/PackageOfferModal";
import ModalValidarTelefone from "~/components/common/modalValidarTelefone/ModalValidarTelefone";
import { buildPackageCheckoutPayload } from "~/utils/checkout/packages";
import { canOfferPackagePurchase, canOfferPendingPackage, getEligibleClientPackages, isOfferEligible } from "~/utils/packages";
import { usePolicyCancellation } from "~/contexts/PolicyCancellationContext";
import Utils from "~/helpers/Utils";
import { limitString } from "~/utils/business";
import DateNavigator from "~/components/common/dateNavigator/DateNavigator";
import ScheduleHeader from "~/components/common/scheduleHeader/ScheduleHeader";
import WhatsAppLoginButton from "~/components/common/whatsappLogin";
import ModalUserName from "~/components/common/ModalUserName";
import { useWhatsAppAuthContext } from "~/contexts/WhatsAppAuthContext";
import { handleBreadcrumb, handleError } from "~/utils/handleError";
import { checkSlotBookingTransaction } from "~/services/bookingTransactionService";
import { activePackageSessions } from "~/services/packagesServices";

const SelectScheduleTime = (props) => {
	const { t, i18n } = useTranslation();
	const bookingId = props?.location?.state?.bookingId;
	const selectedServices = props?.location?.state?.services;
	const reservationUpdate = props?.location?.state?.reservationUpdate;
	const feature_items = props?.location?.state?.feature_items;
	const coupon = props?.location?.state?.coupon;
	const reschedule = props?.location?.state?.reschedule;
	const availableDatesCalendar = props?.location?.state?.availableDatesCalendar;
	const dialog = useContext(DialogBuilder);
	const classes = MuiThemeSelectScheduleTime();
	const { user } = useSelector((store) => store.auth);
	const meStore = useSelector((store) => store.me);
	const me = Utils.safeParseJSON("@prit-web/meData", meStore);
	const { business } = useSelector((store) => store.business);
	const { getPolicyCancellation } = usePolicyCancellation();
	const startedLoggedOut = useRef(!(user && !user?.isAnonymous)).current;
	// True if the booking session started as anonymous (persisted via sessionStorage for post-auth re-entry)
	const wasAnonymousFlow = useRef(
		!(user && !user?.isAnonymous) || sessionStorage.getItem('@prit-web/schedulingStartedLoggedOut') === 'true'
	).current;
	const isLoggedIn = (!me || !me?.name || (!me?.phone && !me?.phoneUnverified) || !user || user?.isAnonymous);

	const { id } = useParams();
	const [message, setMessage] = useState(t("The establishments are closed for this day and time"));
	const [open, setOpen] = useState(false);
	const [showFinishButton, setShowFinishButton] = useState(false);
	const [loading, setLoading] = useState(false);
	const [currentServiceIndex, setCurrentServiceIndex] = useState(0);
	const [servicesScheduled, setServicesScheduled] = useState([]);
	const [serviceTimeOptions, setServiceTimeOptions] = useState([]);
	const [unavailability, setUnavailability] = useState([]);
	const [listProfessionals, setListProfessionals] = useState([]);
	const [alterProfessional, setAlterProfessional] = useState(null);
	const [date, setDate] = useState(props?.location?.state?.date);
	const [, setWhatsAppLoading] = useState(false);
	const [showUserNameModal, setShowUserNameModal] = useState(false);
	const {
		setAuthStatus,
		openModalCustom,
		setOpenModalCustom,
		requestAuthCredential,
		authStatus,
		isLoading: whatsAppAuthLoading,
		showModal: whatsAppShowModal,
		setShowModal: setWhatsAppShowModal,
	} = useWhatsAppAuthContext();

	const isPackage = props?.location?.state?.isPackage;
	const [priceServicePackage, setPriceServicePackage] = useState(0);

	const [animationTrigger, setAnimationTrigger] = useState(0);
	const [externalAnimationDirection, setExternalAnimationDirection] = useState("");

	const {
		availablePackages,
		recommendedPackages,
		acceptPackageOffer,
		loadAvailablePackages,
		setSelectedServices,
	} = useCheckoutPackageOffer();

	const { listSessionsPackage } = useCheckSessionPackage();

	// null = not an anonymous flow (use legacy package UI); [] or populated = anonymous/just-authenticated flow
	const [clientPackages, setClientPackages] = useState([]);
	const [showValidarTelModal, setShowValidarTelModal] = useState(false);
	const [showFallbackLogin, setShowFallbackLogin] = useState(false);
	// Oferta de pacote em sequência, um serviço por vez: { services, queue, index, choices }
	const [packageFlow, setPackageFlow] = useState(null);
	// Serviços aguardando a validação do celular para seguir para a oferta de pacote
	const pendingServicesRef = useRef(null);

	const loginWithWhatsApp = async () => {
		await requestAuthCredential({
			language: i18n?.language || "pt-BR",
			goBackRouteProps: props.location.state,
			showSuccessModal: true,
		});
	};

	const currentUser = me || user || {};
	const isOwnerUser =
		!_.isEmpty(currentUser?.id) && !_.isEmpty(business?.ownerId) && currentUser.id === business.ownerId;

	const initialize = (data, hasUnavailabilities = false) => {
		const newServiceTimeOptions = _.cloneDeep(data);
		(newServiceTimeOptions.services ?? []).forEach((service) => {
			(service.professionals ?? []).forEach((professional) => {
				const duration = Number(professional?.duration) * 60000;
				const lapse = Number(newServiceTimeOptions.business?.timeLapse > 0 ? newServiceTimeOptions.business.timeLapse : professional?.duration) * 60000;
				const vacancies = Number(professional?.vacancies);
				if (!(duration > 0) || !(lapse > 0) || !(vacancies > 0) ||
					!Number.isFinite(duration) || !Number.isFinite(lapse)) {
					professional.schedule = [];
					return;
				}

				const unavailable = (professional?.unavailability ?? []).map((block) => ({
					start: new Date(block.start).getTime(), end: new Date(block.end).getTime(),
				})).filter((block) => block.start < block.end);
				const slots = [];
				const seen = new Set();
				for (const block of professional?.availability ?? []) {
					const start = new Date(block.start).getTime();
					const final = new Date(block.end).getTime();
					if (!(start < final)) continue;
					let current = start + Math.max(0, Math.ceil((Date.now() - start) / lapse)) * lapse;
					while (current + duration <= final) {
						const end = current + duration;
						const collisions = unavailable.filter((block) => block.start < end && block.end > current);
						if (collisions.length < vacancies) {
							if (!seen.has(current)) {
								seen.add(current);
								slots.push({ start: new Date(current).toISOString(), end: new Date(end).toISOString() });
							}
							current += lapse;
						} else {
							current = Math.min(...collisions.map((block) => block.end));
						}
					}
				}
				professional.schedule = slots.sort((a, b) => new Date(a.start) - new Date(b.start))
					.map((slot) => [slot, professional.vacancies]);
			});
		});
		let professionals = [];
		for (let i = 0; i < newServiceTimeOptions.services.length; i++) {
			for (let j = 0; j < newServiceTimeOptions.services[i].professionals.length; j++) {
				if (professionals.findIndex((e) => e.id === newServiceTimeOptions.services[i].professionals[j].id) === -1) {
					professionals.push(newServiceTimeOptions.services[i].professionals[j]);
				}
			}
		}

		setListProfessionals(professionals);

		if (hasUnavailabilities) {
			setUnavailability(professionals);
		}

		setServiceTimeOptions(newServiceTimeOptions);
		let service = newServiceTimeOptions?.services.find((e) => e?.id === selectedServices[0]?.id);

		if (isPackage && service) {
			service.price = selectedServices[0].price;
			setPriceServicePackage(service.price);
		}

		setServicesScheduled([]);
		setShowFinishButton(false);
		const professional = service?.professionals?.find((professional) => professional.schedule?.[0]?.[0]);
		if (professional) {
			setOpen(false);
			selectTime({ time: professional.schedule[0][0], professional, service }, 0, newServiceTimeOptions, professionals);
		} else {
			setOpen(true);
		}

		try {
			setSelectedServices(selectedServices || []);
			if (business?.id && business?.language) {
				loadAvailablePackages(business.id, business.language);
			}
		} catch (_) {}
	};

	useEffect(() => {
		if (startedLoggedOut) {
			sessionStorage.setItem('@prit-web/schedulingStartedLoggedOut', 'true');
		}
		handleBreadcrumb('scheduling.time', 'Abriu seleção de horário', {
			businessId: id,
			date: props?.location?.state?.date,
			serviceCount: selectedServices?.length,
		});
		if (selectedServices?.length === 0) {
			props.history.push(`/business/${id}`);
		}
		let dates = {
			start_time: dayjs(date).startOf("day").utc().format(),
			end_time: dayjs(date).endOf("day").utc().format(),
		};
		let featureItems;
		if (selectedServices) {
			featureItems = selectedServices.map((service) => {
				return service.featureItems;
			});
		}

		setLoading(true);
		if (coupon) {
			couponServices
				.postSearchCoupon({
					...dates,
					business_id: business.id,
					services: featureItems,
					coupon_id: coupon?.coupon.coupon_id,
				})
				.then(({ data }) => {
					if (data.length === 0) {
						setOpen(true);
					}
					var newData = camelizeKeys(data[0]);
					initialize(newData);
					setLoading(false);
				})
				.catch((e) => {
					handleError(e, 'SelectScheduleTime/postSearchCoupon');
					dialog
						.withTitle(t("The services are unavailable at the moment."))
						.withAction(() => props.history.goBack())
						.show();
					setLoading(false);
				});
		} else {
			searchService
				.postSearch({ ...dates, business_id: business.id, services: featureItems, language: business.language })
				.then(({ data }) => {
					if (data.length === 0) {
						setOpen(true);
						return;
					}
					if (data[0].services.length < selectedServices.length) {
						dialog
							.withTitle(t("There are no professionals available for these services at the moment"))
							.withAction(() => props.history.goBack())
							.show();
						return;
					}
					initialize(data[0], true);
					setLoading(false);
				})
				.catch((e) => {
					handleError(e, 'SelectScheduleTime/postSearch');
					dialog
						.withTitle(t("The services are unavailable at the moment."))
						.withAction(() => props.history.goBack())
						.show();
					setLoading(false);
				});
		}
	}, [date]);

	const getUnavailableSlots = (servicesScheduled, currentServiceId, currentProfessionalId, allUnavailabilities) => {
		let unavailableSlots = [];

		let professionalUnavailability = allUnavailabilities.find((u) => u.id === currentProfessionalId);
		if (professionalUnavailability) {
			unavailableSlots.push(...professionalUnavailability.unavailability);
		}

		servicesScheduled.forEach((selectedSchedule) => {
			if (selectedSchedule && selectedSchedule.service.id !== currentServiceId) {
				if (selectedSchedule.professional.id === currentProfessionalId) {
					const startTime = new Date(selectedSchedule.time.start);
					const duration = selectedSchedule.professional?.duration || 60;
					const endTime = new Date(startTime.getTime() + duration * 60 * 1000);

					unavailableSlots.push({
						start: startTime.toUTCString(),
						end: endTime.toUTCString(),
					});
				}
			}
		});

		return unavailableSlots;
	};

	function findNextAvailableProfessional(selectedTime, service) {
		if (!service) {
			return null;
		}

		for (let i = 0; i < service.length; i++) {
			const professional = service[i];
			if (professional.schedule && Array.isArray(professional.schedule)) {
				for (let j = 0; j < professional.schedule.length; j++) {
					const slot = professional.schedule[j];

					if (Array.isArray(slot) && slot.length > 0) {
						const timeSlot = slot[0];

						if (timeSlot && timeSlot.start && timeSlot.end) {
							if (
								new Date(timeSlot.start).getTime() === new Date(selectedTime.start).getTime() &&
								new Date(timeSlot.end).getTime() === new Date(selectedTime.end).getTime()
							) {
								return professional;
							}
						}
					}
				}
			}
		}
		return null;
	}

	const selectTime = (schedule, currentService, options, unavailabilities) => {
		if (!business.allowSelectProfessional) {
			const nextProfessional =
				findNextAvailableProfessional(schedule.time, unavailabilities ?? listProfessionals) ?? null;
			setAlterProfessional(nextProfessional);
		}
		let services = options ? [] : [...(servicesScheduled || [])];

		// Marcar/Desmarcar o horário.
		const isDeselecting =
			services[currentService ?? currentServiceIndex] &&
			services[currentService ?? currentServiceIndex].time.start === schedule.time.start;

		if (isDeselecting) {
			services[currentService ?? currentServiceIndex] = null;
		} else {
			services[currentService ?? currentServiceIndex] = schedule;
		}
		setServicesScheduled(services);

		let newServiceTimeOptions = options ? _.cloneDeep(options) : _.cloneDeep(serviceTimeOptions);
		let newUnavailbility = unavailabilities ? _.cloneDeep(unavailabilities) : _.cloneDeep(unavailability);

		let currentUnavailableSlots;
		let professional;

		let allTimesDefined = services.every((service) => service);
		if (allTimesDefined) {
			setShowFinishButton(true);
		}

		newServiceTimeOptions.services.forEach((service, i) => {
			if (service.id !== schedule.service.id) {
				let targetProfessionalId;
				if (!business?.allowSelectProfessional) {
					if (!service.professionals || service.professionals.length === 0) {
						return;
					}
					targetProfessionalId = service.professionals[0].id;
				} else {
					targetProfessionalId = schedule.professional.id;
				}

				let professionalIndex = newUnavailbility.findIndex((e) => e.id === targetProfessionalId);
				if (professionalIndex === -1) {
					return;
				}
				professional = newUnavailbility[professionalIndex];

				let newSlots = [];

				const serviceProfessional = service.professionals.find((p) => p.id === professional.id);
				const serviceDuration = serviceProfessional?.duration || professional.duration || 60;

				let timeLapse =
					newServiceTimeOptions.business.timeLapse > 0 ? newServiceTimeOptions.business.timeLapse : serviceDuration;

				currentUnavailableSlots = getUnavailableSlots(services, service.id, professional.id, newUnavailbility);

				const duration = Number(serviceDuration) * 60000;
				const lapse = Number(timeLapse) * 60000;
				const vacancies = Number(professional?.vacancies);
				if (!(duration > 0) || !(lapse > 0) || !(vacancies > 0) ||
					!Number.isFinite(duration) || !Number.isFinite(lapse)) {
					professional.schedule = [];
					return;
				}

				const unavailable = currentUnavailableSlots.map((block) => ({
					start: new Date(block.start).getTime(), end: new Date(block.end).getTime(),
				})).filter((block) => block.start < block.end);
				const slots = [];
				const seen = new Set();
				for (const block of professional?.availability ?? []) {
					const start = new Date(block.start).getTime();
					const final = new Date(block.end).getTime();
					if (!(start < final)) continue;
					let current = start + Math.max(0, Math.ceil((Date.now() - start) / lapse)) * lapse;
					while (current + duration <= final) {
						const end = current + duration;
						const collisions = unavailable.filter((block) => block.start < end && block.end > current);
						if (collisions.length < vacancies) {
							if (!seen.has(current)) {
								seen.add(current);
								slots.push({ start: new Date(current).toISOString(), end: new Date(end).toISOString() });
							}
							current += lapse;
						} else {
							current = Math.min(...collisions.map((block) => block.end));
						}
					}
				}
				newSlots = slots.sort((a, b) => new Date(a.start) - new Date(b.start))
					.map((slot) => [slot, professional.vacancies]);

				const serviceInOptions = newServiceTimeOptions.services.find((s) => s.id === service.id);
				if (serviceInOptions) {
					if (!business?.allowSelectProfessional) {
						if (serviceInOptions.professionals && serviceInOptions.professionals.length > 0) {
							serviceInOptions.professionals[0].schedule = newSlots;
							for (let j = 1; j < serviceInOptions.professionals.length; j++) {
								serviceInOptions.professionals[j].schedule = [];
							}
						}
					} else {
						const profInService = serviceInOptions.professionals.find((p) => p.id === professional.id);
						if (profInService) {
							profInService.schedule = newSlots;
						}
					}
				}
			}
		});

		setServiceTimeOptions(newServiceTimeOptions);
	};

	// ─── Oferta de pacote ─────────────────────────────────────────────────────
	// Deslogado: valida o celular no "Próximo" e, logo depois de autenticar, oferece
	// pacote (da cliente ou à venda) para cada serviço. Logado: a mesma oferta, direto
	// no "Próximo" — o saldo da cliente é tratado aqui, não no checkout.

	const professionalIdOf = (schedule) => (alterProfessional ? alterProfessional.id : schedule?.professional?.id);

	// Com política ativa e outro serviço de preço fixo no agendamento, não oferece
	// compra: não existe endpoint para comprar pacote e pagar avulso juntos
	const offersFor = (schedule, selectedSchedules = []) => {
		const otherPricingTypes = selectedSchedules
			.filter((s) => s && s.service?.id !== schedule?.service?.id)
			.map((s) => s.professional?.pricingType);
		const isPolicyActive = !!getPolicyCancellation(business?.id)?.isPolicyCancellationActive;
		if (!canOfferPackagePurchase(isPolicyActive, otherPricingTypes)) return [];
		return (recommendedPackages || []).filter(
			(pkg) =>
				pkg.service?.id === schedule?.service?.id &&
				(!pkg.professional?.id || pkg.professional.id === professionalIdOf(schedule)) &&
				isOfferEligible(pkg)
		);
	};

	const hasPackageOptions = (schedule, clientPkgs, selectedSchedules) => {
		if (!schedule) return false;
		const own = getEligibleClientPackages(
			clientPkgs,
			schedule.service.id,
			professionalIdOf(schedule),
			schedule.time?.start
		);
		return own.length > 0 || offersFor(schedule, selectedSchedules).length > 0;
	};

	const startPackageFlow = async (services) => {
		let clientPkgs = [];
		if (business?.id) {
			try {
				const servicesPayload = services.map((s) => ({
					service_id: s.service?.id,
					professional_id: professionalIdOf(s),
				}));
				const res = await activePackageSessions(business.id, servicesPayload);
				const isPolicyActive = !!getPolicyCancellation(business.id)?.isPolicyCancellationActive;
				clientPkgs = (res.data || []).filter((pkg) => canOfferPendingPackage(pkg, isPolicyActive, services.length));
			} catch (_) {
				// non-critical — continue without client packages
			}
		}
		setClientPackages(clientPkgs);

		const queue = services.filter((s) => hasPackageOptions(s, clientPkgs, services));
		if (queue.length === 0) {
			goToNextPage(services, [], null, {}, clientPkgs);
			return;
		}
		setPackageFlow({ services, queue, index: 0, choices: {}, clientPkgs });
	};

	// Compra vira selectedPackages (o checkout já compra e agenda); uso de pacote e
	// avulso seguem em packageChoices para o checkout montar a revisão.
	const finishPackageFlow = ({ services, choices, clientPkgs }) => {
		const newPackages = [];
		let lastPackage = null;
		const checkoutChoices = {};
		Object.keys(choices).forEach((serviceId) => {
			const choice = choices[serviceId];
			if (choice.type !== "purchase") {
				checkoutChoices[serviceId] = choice;
				return;
			}
			const schedule = services.find((s) => String(s?.service?.id) === String(serviceId));
			acceptPackageOffer(choice.offer.id);
			const packagePayload = buildPackageCheckoutPayload(choice.offer, schedule);
			if (packagePayload) {
				// guarda o serviço para o "Trocar" do checkout poder voltar ao avulso
				const withService = { ...packagePayload, checkoutService: toCheckoutService(schedule) };
				newPackages.push(withService);
				lastPackage = withService;
			}
		});
		goToNextPage(services, newPackages, lastPackage, checkoutChoices, clientPkgs);
	};

	const handlePackageFlowChoice = (choice) => {
		if (!packageFlow) return;
		const { queue, index, choices } = packageFlow;
		const serviceId = queue[index].service.id;
		const nextFlow = { ...packageFlow, choices: { ...choices, [serviceId]: choice } };
		if (index + 1 < queue.length) {
			setPackageFlow({ ...nextFlow, index: index + 1 });
			return;
		}
		setPackageFlow(null);
		finishPackageFlow(nextFlow);
	};

	const handleFinish = (services) => {
		if (isPackage || reschedule || services.some((s) => !s)) {
			goToNextPage(services);
			return;
		}
		const hasPackages = availablePackages?.length > 0 || recommendedPackages?.length > 0;
		if (wasAnonymousFlow && (!user || user?.isAnonymous) && hasPackages) {
			pendingServicesRef.current = services;
			setShowValidarTelModal(true);
			return;
		}
		startPackageFlow(services);
	};

	// Serviço no formato do payload do checkout
	const toCheckoutService = (schedule) => {
		return {
			date: schedule.time.start,
			service_id: schedule.service.id,
			professional_id: alterProfessional ? alterProfessional.id : schedule.professional.id,
			professional: {
				duration: alterProfessional ? alterProfessional.duration : schedule.professional.duration,
				id: alterProfessional ? alterProfessional.id : schedule.professional.id,
				name: alterProfessional ? alterProfessional.name : schedule.professional.name,
				price: schedule.service.price,
				pricingType: schedule?.professional?.pricingType || "",
				avatarUrl: alterProfessional ? alterProfessional.avatarUrl : schedule.professional.avatarUrl,
			},
			service: {
				serviceDuration: alterProfessional ? alterProfessional.duration : schedule.professional.duration,
				serviceName: schedule.service.name ?? schedule.service.serviceName,
				servicePrice: schedule.service.price,
				featureItems: selectedServices.find((s) => s.id === schedule.service.id)?.featureItems,
			},
			dateStart: schedule.time.start,
		};
	};

	const goToNextPage = async (
		services,
		packagesOverride = null,
		infoPackageOverride = null,
		packageChoices = {},
		clientPkgs = clientPackages
	) => {
		if (!services || !Array.isArray(services) || services.length === 0) {
			return;
		}

		const packagesToUse = packagesOverride !== null ? packagesOverride : [];
		const infoPackageToUse = infoPackageOverride;

		for (let i = 0; i < services.length; i++) {
			if (!services[i]) {
				const messageText =
					t("You forgot to select the time for the") +
					(i + 1) +
					t("service, please set a time for it before continuing");
				if (isOwnerUser) {
					mixpanelTrackEvent("Tentativa_Avancar_Horario", { Erro_Disparado: messageText }, currentUser, business);
				}
				setMessage(messageText);
				setOpen(true);
				return;
			}
		}
		if (isOwnerUser) {
			const serviceNamesSelected = services
				.map((s) => s.service.name ?? s.service.serviceName)
				.sort((a, b) => a.localeCompare(b))
				.join(", ");
			const serviceTimesSelected = services
				.map((s) => s.time.start)
				.map((d) => new Intl.DateTimeFormat("pt-BR", { hour: "2-digit", minute: "2-digit" }).format(new Date(d)))
				.join(", ");
			const eventProps = {
				Servicos_Selecionados: serviceNamesSelected,
				Data_Selecionada: new Date(date).toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", year: "numeric" }),
				Horario_Selecionado: serviceTimesSelected,
			};
			mixpanelTrackEvent("Avancar_Horario", eventProps, currentUser, business);
		}

		handleBreadcrumb('scheduling.time', 'Horário selecionado, avançando para checkout', {
			serviceCount: services?.length,
			times: services?.map((s) => s.time?.start),
		});

		let payload = {
			recipientId: id,
			questions: serviceTimeOptions.questions,
			services: services
				.filter((service) => {
					const hasPackageForService = packagesToUse.some(
						(pkg) => pkg?.body?.bookings?.[0]?.service_id === service?.service?.id
					);
					return !hasPackageForService;
				})
				.map(toCheckoutService),
			bookingId: bookingId,
			reservationUpdate: reservationUpdate,
			verification: true,
			feature_items: feature_items,
			coupon: coupon,
			reschedule: reschedule,
			schedulingServicePackage: isPackage ?? false,
			selectedPackages: packagesToUse,
			infoPackage: infoPackageToUse,
			packageSessionInfo: props?.location?.state?.packageSessionInfo,
			packageChoices: packageChoices,
			clientPackages: clientPkgs,
			packageFlow: wasAnonymousFlow ? "anonymous" : "logged",
		};

		// Verify if the user already has an identical booking for any selected slot.
		// If so, redirect directly to the confirmation screen instead of creating a duplicate.
		if (!isLoggedIn) return props.history.push(`/checkout/${id}`, { ...payload, slotChecked: false });
		const slotsToCheck = payload.services.map((service) => ({
			professional_id: service.professional_id,
			service_id: service.service_id,
			start_time: service.date,
			business_id: id,
		}));
		if (slotsToCheck.length > 0) try {
			const { data: checkResults } = await checkSlotBookingTransaction(slotsToCheck);

			const existingResult = Array.isArray(checkResults) ? checkResults.find((r) => r?.exists) : null;
			if (existingResult) {
				const bookingTransactionId = existingResult.bookingTransactionId || existingResult.booking_transaction_id;
				props.history.push(
					`/confirmation/${id}/bookingTransactionId/${bookingTransactionId}`,
					{ fromCheckSlot: true }
				);
				return;
			}
		} catch (_e) {
			// If check_slot fails for any reason, continue to normal checkout flow
		}

		props.history.push(`/checkout/${id}`, { ...payload, slotChecked: true });
	};

	const handleOk = () => {
		setOpen(!open);
		setLoading(false);
	};

	const goToPreviousService = () => {
		if (currentServiceIndex > 0) {
			setExternalAnimationDirection("prev");
			setCurrentServiceIndex(currentServiceIndex - 1);
			setAnimationTrigger((prev) => prev + 1);
		}
	};

	const goToNextService = () => {
		advanceToNextService();
	};

	const advanceToNextService = () => {
		if (currentServiceIndex < selectedServices.length - 1) {
			setExternalAnimationDirection("next");
			setCurrentServiceIndex(currentServiceIndex + 1);
			setAnimationTrigger((prev) => prev + 1);
		}
	};

	const footer = () => {
		return (
			<>
			<div style={{ margin: "20px" }}>
					<ColorButton
						translate="no"
						variant="contained"
						style={{
							backgroundColor: "#672E37",
							color: "white",
							width: "100%",
						}}
						className={classes.nameButton}
						onClick={() => {
							if (currentServiceIndex === selectedServices.length - 1) {
								let services = [
									{
										...servicesScheduled[0],
										service: !isPackage
											? { ...servicesScheduled[0].service, price: servicesScheduled[0].professional.price }
											: { ...servicesScheduled[0].service },
									},
									...servicesScheduled.slice(1),
								];
								handleFinish(services);
							} else {
								goToNextService();
								if (!servicesScheduled[currentServiceIndex + 1]) {
									let service = serviceTimeOptions?.services.find(
										(e) => e?.id === selectedServices[currentServiceIndex + 1]?.id
									);
									const professional = service?.professionals?.find((professional) => professional.schedule?.[0]?.[0]);
									if (!professional) return;
									service = { ...service, price: professional.price };
									let schedule = !isPackage
										? professional.schedule
										: { ...servicesScheduled[0].service };
									if (!_.isEmpty(schedule) && !_.isEmpty(schedule[0])) {
										selectTime(
											{
												time: schedule[0][0],
												professional: professional,
												service: service,
											},
											currentServiceIndex + 1
										);
									}
								}
							}
						}}>
						{/* flex: 1 garante que o span preenche o label do MUI Button e o texto longo trunca com reticências */}
						<span style={{ display: "block", flex: 1, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
							{currentServiceIndex === selectedServices.length - 1
								? t("Next")
								: t("Choose time for service", {
										service: selectedServices[currentServiceIndex + 1]?.name ?? selectedServices[currentServiceIndex + 1]?.serviceName,
								  })}
						</span>
					</ColorButton>
				</div>
			</>
		);
	};

	useEffect(() => {
		if (openModalCustom === "REGISTER_NAME_USER" && _.isEmpty(!me?.name)) {
			setShowUserNameModal(true);
		}
	}, [openModalCustom]);

	// Autenticou: mostra o "Número validado" por um instante e já oferece o pacote.
	// Sem nome cadastrado, espera o ModalUserName fechar.
	useEffect(() => {
		if (!user || user?.isAnonymous) return;
		setShowFallbackLogin(false);
		if (!pendingServicesRef.current || showUserNameModal) return;
		const timer = setTimeout(() => {
			const services = pendingServicesRef.current;
			pendingServicesRef.current = null;
			setShowValidarTelModal(false);
			if (services) startPackageFlow(services);
		}, 2000);
		return () => clearTimeout(timer);
	}, [user?.isAnonymous, showUserNameModal]);

	// Prevent context's ModalWhatsAppAuth from opening while ModalValidarTelefone is handling the flow
	useEffect(() => {
		if (showValidarTelModal && whatsAppShowModal) {
			setWhatsAppShowModal(false);
		}
	}, [whatsAppShowModal]);

	useEffect(() => {
		if (!availablePackages?.length) return;
		if (!selectedServices?.length) return;

		const servicesPayload = selectedServices
			.map((service, idx) => {
				const scheduledProfessional = servicesScheduled[idx]?.professional;
				const fallbackProfessional = serviceTimeOptions?.services
					?.find((s) => s?.id === service?.id)
					?.professionals?.[0];
				const professional = scheduledProfessional || fallbackProfessional;
				if (!service?.id || !professional?.id) return null;
				return { service_id: service.id, professional_id: professional.id };
			})
			.filter(Boolean);

		if (servicesPayload.length === 0) return;

		listSessionsPackage(servicesPayload);
	}, [currentServiceIndex, selectedServices, servicesScheduled, availablePackages?.length, user?.uid]);

	return (
		<>
			<TitleContainer
				handleClick={() => props.history.goBack()}
				footer={footer()}
				backgroundNew={true}
				loading={loading}
				imageVisible={true}
				showGradient={false}
				childrenStyle={{ padding: 0 }}
				rightElement={
					<div style={{ backgroundColor: "rgba(0,0,0,0.8)", borderRadius: 50, padding: "4px 10px" }}>
						<Typography style={{ fontSize: 16, color: "#fff", fontWeight: "300" }}>
							{t("{{actualStep}} of {{finishStep}}", {
								actualStep: 3,
								finishStep: wasAnonymousFlow ? 5 : 4,
							})}
						</Typography>
					</div>
				}>
				<SEO business={business} page="Horários" />
				<ScheduleHeader
					title={selectedServices?.length > 1 ? t("Choose the time for each service") : t("Select time")}
					subtitle={t("You are scheduling with", {
						professionalOrBusiness: business?.allowSelectProfessional
							? `${servicesScheduled?.[0]?.professional?.name} - ${business?.name}`
							: business?.name,
					})}
					view={"selectTime"}
				/>
				<div className={classes.scrollSelectedArea} style={{ marginBottom: 30 }}>
					{serviceTimeOptions?.services?.length > 0 ? (
						<FeaturesSelected
							serviceLayout={true}
							features={selectedServices}
							currentIndex={currentServiceIndex}
							setCurrentIndex={(index) => {
								setAnimationTrigger((prev) => prev + 1);
								setCurrentServiceIndex(index);
							}}
							singleServiceView={true}
							animate={animationTrigger}
							externalAnimationDirection={externalAnimationDirection}
						/>
					) : (
						!loading && <Typography className={classes.noneServices}>Você removeu todos os serviços</Typography>
					)}
				</div>
				<ModalBottom
					animationType="slideUp"
					animate={animationTrigger}
					style={{
						maxWidth: "480px",
						margin: "0 auto",
						width: "100%",
						flex: 1,
						position: "relative",
						paddingBottom: "clamp(70px, 8vh, 120px)",
					}}>
					{/* X alinhado com a data: flex row, sem position absolute */}
					<div style={{ display: "flex", alignItems: "center" }}>
						<div style={{ flex: 1 }}>
							<DateNavigator date={date} availableDatesCalendar={availableDatesCalendar} onDateChange={setDate} />
						</div>
						{currentServiceIndex > 0 && (
							<div
								onClick={goToPreviousService}
								style={{
									cursor: "pointer",
									padding: "6px",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									borderRadius: "50%",
									backgroundColor: "rgba(0,0,0,0.05)",
									flexShrink: 0,
								}}>
								<Close style={{ fontSize: 20, color: "#666" }} />
							</div>
						)}
					</div>
					<Divider style={{ margin: "5px 0" }} />
					{business?.allowSelectProfessional && serviceTimeOptions?.services?.length > 0 && date ? (
						serviceTimeOptions?.services
							.filter((e) => e.id === selectedServices[currentServiceIndex].id)[0]
							?.professionals.map((professional, index) => {
								const service = serviceTimeOptions?.services?.find(
									(e) => e?.id === selectedServices[currentServiceIndex]?.id
								);
								const professionalsOfService = service?.professionals?.length > 1 ? true : false;
								let isAutomaticSelected = professional?.schedule?.length === 1;
								return (
									<div
										key={`professional-${index}`}
										style={{
											padding: listProfessionals?.length === 1 && currentServiceIndex > 0 ? "30px 0" : "10px 0",
										}}>
										<ProfessionalDiv
											professional={professional}
											professionalView
											isPackage={isPackage}
											priceServicePackage={priceServicePackage}
										/>
										<TimeOptionsDiv
											options={professional.schedule}
											onSelect={selectTime}
											professional={professional}
											professionalIndex={index}
											selected={servicesScheduled.find(
												(e) => e?.service?.id === selectedServices[currentServiceIndex]?.id
											)}
											service={serviceTimeOptions?.services.find(
												(e) => e?.id === selectedServices[currentServiceIndex]?.id
											)}
											timeZone={business.timeZone}
											listProfessionals={listProfessionals}
											setDate={setDate}
											date={date}
											availableDatesCalendar={availableDatesCalendar}
											allowSelectProfessional={business?.allowSelectProfessional}
											professionalsOfService={professionalsOfService}
											servicesSchedule={serviceTimeOptions?.services}
											servicesScheduled={servicesScheduled}
											business={business}
											unavailableSlots={professional.unavailability ?? []}
										/>
										{isAutomaticSelected && !professionalsOfService && (
											<div style={{ display: "flex", alignItems: "center", gap: 4, paddingTop: 8 }}>
												<ErrorOutline style={{ color: "rgba(0,0,0,0.65)", fontSize: 18 }} />
												<Typography
													style={{
														fontSize: 16,
														color: "rgba(0,0,0,0.65)",
														fontWeight: 500,
														fontFamily: "CircularStd",
														lineHeight: 1.2,
														fontStyle: "italic",
													}}>
													{t("This time has been automatically selected")}
												</Typography>
											</div>
										)}
									</div>
								);
							})
					) : (
						<>
							{serviceTimeOptions?.services?.length > 0 &&
								(() => {
									const foundService = serviceTimeOptions?.services?.find(
										(e) => e?.id === selectedServices[currentServiceIndex]?.id
									);
									const professional = foundService?.professionals?.[0];
									const isAutomaticSelected = professional?.schedule?.length === 1;

									return (
										<>
											<BusinessDiv
												service={(() => {
													if (foundService && foundService.professionals && foundService.professionals.length > 0) {
														return {
															...serviceTimeOptions,
															pricingType: {
																id: foundService.professionals[0].pricingType.id,
																name: foundService.professionals[0].pricingType,
															},
														};
													}
													return foundService;
												})()}
												selectedService={currentServiceIndex}
												currentService={selectedServices[currentServiceIndex]}
												showNextDayButton={true}
												onNextDayClick={() => {
													const availableDatesCalendar = props?.location?.state?.availableDatesCalendar;
													if (!date || !availableDatesCalendar || availableDatesCalendar.length === 0) return;

													const currentDateString = new Date(date).toISOString().split("T")[0]; // usa o estado
													const futureDates = availableDatesCalendar.filter((d) => d > currentDateString);

													if (futureDates.length > 0) {
														const nextDateString = futureDates[0];
														setDate(new Date(nextDateString + "T00:00:00"));
													} else {
														setDate(new Date(availableDatesCalendar[0] + "T00:00:00"));
													}
												}}
											/>
											<TimeOptionsDiv
												onSelect={selectTime}
												selected={servicesScheduled.find(
													(e) => e?.service?.id === selectedServices[currentServiceIndex]?.id
												)}
												service={selectedServices[currentServiceIndex]}
												timeZone={business.timeZone}
												professionals={
													!business?.allowSelectProfessional && foundService?.professionals
														? [foundService.professionals[0]]
														: foundService?.professionals
												}
												listProfessionals={listProfessionals}
												setDate={setDate}
												date={date}
												availableDatesCalendar={availableDatesCalendar}
												allowSelectProfessional={business?.allowSelectProfessional}
												professional={professional}
												servicesSchedule={serviceTimeOptions?.services}
												servicesScheduled={servicesScheduled}
												business={business}
												unavailableSlots={professional?.unavailability ?? []}
											/>
											{isAutomaticSelected && (
												<div style={{ display: "flex", alignItems: "center", gap: 4, paddingTop: 8 }}>
													<ErrorOutline style={{ color: "rgba(0,0,0,0.65)", fontSize: 18 }} />
													<Typography
														style={{
															fontSize: 16,
															color: "rgba(0,0,0,0.65)",
															fontWeight: 500,
															fontFamily: "CircularStd",
															lineHeight: 1.2,
															fontStyle: "italic",
														}}>
														{t("This time has been automatically selected")}
													</Typography>
												</div>
											)}
										</>
									);
								})()}
						</>
					)}
					<div>
						{(() => {
							if (!_.isEmpty(servicesScheduled) && servicesScheduled.length > 1) {
								return servicesScheduled.slice(0, currentServiceIndex).map((service, index) => (
									<Typography key={index} style={{ display: "flex", alignItems: "center", gap: "8px", marginTop: 10 }}>
										<div
											style={{
												width: "20px",
												height: "20px",
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												backgroundColor: "#50A0A0",
												borderRadius: "50%",
												padding: "2px",
											}}>
											<Check style={{ color: "#fff", fontSize: "16px" }} />
										</div>
										{t("You selected {{hours}} with {{professional}}", {
											hours: dayjs(service?.time.start).format("HH:mm"),
											professional: limitString(service?.professional.name, 15),
										})}
									</Typography>
								));
							}
						})()}
					</div>
				</ModalBottom>
				<ErrorDialog onOpen={open} message={message} onOk={handleOk} title={t("Attention")} />
			</TitleContainer>
			{packageFlow && (() => {
				const schedule = packageFlow.queue[packageFlow.index];
				const professional = alterProfessional || schedule.professional;
				return (
					<PackageOfferModal
						key={`package-flow-${packageFlow.index}`}
						open={true}
						onClose={() => setPackageFlow(null)}
						recommendedPackages={offersFor(schedule, packageFlow.services)}
						services={[
							{
								id: schedule.service.id,
								name: schedule.service.name ?? schedule.service.serviceName,
								price: schedule.service.price ?? schedule.professional?.price,
							},
						]}
						currentServiceIndex={0}
						servicesFormatted={[{ ...schedule, professional }]}
						currency={business?.currency}
						clientPackages={packageFlow.clientPkgs}
						onChoose={handlePackageFlowChoice}
						stepIndex={packageFlow.index}
						stepTotal={packageFlow.queue.length}
					/>
				);
			})()}
			<ModalValidarTelefone
				open={showValidarTelModal}
				onClose={() => {
					pendingServicesRef.current = null;
					setShowValidarTelModal(false);
				}}
				services={selectedServices || []}
				scheduledDate={date}
				servicesScheduled={servicesScheduled}
				onAutoClose={() => setShowValidarTelModal(false)}
				currentStep={4}
				totalSteps={5}
				onLoginWithWhatsApp={loginWithWhatsApp}
				authStatus={authStatus}
				isLoading={whatsAppAuthLoading}
				isAuthenticated={!!(user && !user.isAnonymous)}
				phoneNumber={user?.phoneNumber || me?.phone || me?.phoneUnverified}
				onFallback={() => {
					setShowValidarTelModal(false);
					setShowFallbackLogin(true);
				}}
			/>
			{showFallbackLogin && (
				<WhatsAppLoginButton
					showCustomLogin={true}
					successRoute={`/selecionar-horarios/${id}`}
					label={t("verify with whatsapp")}
					business={business}
					onLoadingChange={setWhatsAppLoading}
					language={i18n?.language || "pt-BR"}
					goBackRouteProps={props.location.state}
					onCustomLoginClose={() => {
						pendingServicesRef.current = null;
						setShowFallbackLogin(false);
					}}
				/>
			)}
			<ModalUserName
				open={showUserNameModal}
				onClose={() => {
					setShowUserNameModal(false);
					if (openModalCustom === "REGISTER_NAME_USER") {
						setOpenModalCustom(false);
						if (!_.isEmpty(me?.name)) {
							setAuthStatus("SUCCESS");
						}
					}
				}}
			/>
		</>
	);
};
export default withRouter(SelectScheduleTime);
